import React from "react";
import { FaGithub, FaLinkedin, FaEnvelope } from "react-icons/fa";
import { SiLeetcode } from "react-icons/si";
import profileImage from "../assets/images/profile.jpeg";

const Profile = ({ isMobile }) => {
  return (
    <div
      className={`${
        isMobile ? "flex flex-col gap-10" : "flex flex-row gap-12 p-8"
      } h-full`}
    >
      <div className={`${isMobile ? "flex justify-center" : "flex-shrink-0"}`}>
        <img
          src={profileImage}
          alt="Profile"
          className={`${
            isMobile ? "w-40 h-40" : "w-40 h-40"
          } object-cover border-4 border-blue-500 rounded-full`}
        />
      </div>

      <div
        className={`${
          isMobile ? "flex-grow" : "flex-grow flex flex-col justify-center"
        }`}
      >
        <h2
          className={`${
            isMobile ? "text-3xl" : "text-2xl md:text-3xl"
          } font-bold text-blue-600 ${isMobile ? "mb-3" : "mb-2"}`}
        >
          Dhruv Atri
        </h2>
        <h3
          className={`${
            isMobile ? "text-xl" : "text-lg md:text-xl"
          } text-gray-600 ${isMobile ? "mb-6" : "mb-4"}`}
        >
          Full Stack Developer
        </h3>

        <div className={isMobile ? "mb-10" : "mb-5"}>
          <p
            className={`${
              isMobile ? "text-lg" : "text-sm md:text-base"
            } flex items-center gap-2`}
          >
            <FaEnvelope
              className={`${isMobile ? "text-2xl" : "text-xl"} text-blue-500`}
            />
            <a href="mailto:dhruvatri001@gmail.com" className="hover:underline">
              dhruvatri001@gmail.com
            </a>
          </p>
        </div>

        <div className={isMobile ? "mb-10" : "mb-6"}>
          <h4
            className={`${
              isMobile ? "text-2xl" : "text-sm md:text-base"
            } font-semibold ${isMobile ? "mb-4" : "mb-2"}`}
          >
            About Me
          </h4>
          <p
            className={`${
              isMobile ? "text-lg" : "text-xs md:text-sm"
            } text-gray-700 leading-relaxed`}
          >
            Passionate developer proficient in JavaScript, React.js, Node.js,
            and cloud technologies, while currently expanding my expertise with
            Java and Spring Boot. I build user-friendly, clean, and maintainable
            web applications that enhance the user experience. When I'm not
            coding, you can find me taking beach walks or reading.
          </p>
        </div>

        <div>
          <h4
            className={`${
              isMobile ? "text-2xl" : "text-sm md:text-base"
            } font-semibold ${isMobile ? "mb-4" : "mb-2"}`}
          >
            Connect with me
          </h4>
          <div className={`flex ${isMobile ? "gap-8" : "gap-6"}`}>
            <a
              href="https://github.com/dhruvatri"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-700 hover:text-blue-600"
            >
              <FaGithub size={isMobile ? 32 : 20} />
            </a>
            <a
              href="https://linkedin.com/in/dhruvatri001"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-700 hover:text-blue-600"
            >
              <FaLinkedin size={isMobile ? 32 : 20} />
            </a>
            <a
              href="https://leetcode.com/coderack"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-700 hover:text-blue-600"
            >
              <SiLeetcode size={isMobile ? 32 : 20} />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
